import { render, staticRenderFns } from "./StatisticDashboard.vue?vue&type=template&id=3d2b7506&"
import script from "./StatisticDashboard.vue?vue&type=script&lang=js&"
export * from "./StatisticDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports